import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAt, faDollarSign, faHashtag, faSave, faTimes } from '@fortawesome/free-solid-svg-icons';

class Crear extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        ID_COD_DPTO: '',
        ID_COD_MPIO: '',
        NOMBRE: '',
        NIT_ALCALDIA: '',
        CUENTA_FIDUCIA: '',
        BANCO_FIDUCIA: '',
        NOMBRE_FIDUCIA: '',
        NIT_FIDUCIA: '',
        DIRECCION_ALCALDIA: '',
        TELEFONO_ALCALDIA: '',
        CORREO_ELECTRONICO_ALCALDIA: '',
        NOMBRE_SEC_HACIENDA: '',
        CUENTA_DESTINO: '',
        BANCO_DESTINO: '',
        CONCEPTO_APORTE: '',
        VALOR_CONCEPTO: '',
        VALOR_CARTERA: '',
        departamentos: [],
        municipios: [],
        errores: [],
    }
    cambioValor = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errores: [] })
    }
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }
    enviarDatos = (e) => {
        e.preventDefault();
        const { ID_COD_DPTO, ID_COD_MPIO, NOMBRE, NIT_ALCALDIA, CUENTA_FIDUCIA, BANCO_FIDUCIA, NOMBRE_FIDUCIA, NIT_FIDUCIA, DIRECCION_ALCALDIA, TELEFONO_ALCALDIA, CORREO_ELECTRONICO_ALCALDIA, NOMBRE_SEC_HACIENDA, CUENTA_DESTINO, BANCO_DESTINO, CONCEPTO_APORTE, VALOR_CONCEPTO, VALOR_CARTERA } = this.state;
        var errores = [];
        if (!ID_COD_DPTO) { errores.push("error_id_departamento"); }
        if (!ID_COD_MPIO) { errores.push("error_id_municipio"); }
        if (!NOMBRE) { errores.push("error_nombre"); }
        if (!NIT_ALCALDIA) { errores.push("error_nit"); }
        if (!CUENTA_FIDUCIA) { errores.push("error_ctafiducia"); }
        if (!BANCO_FIDUCIA) { errores.push("error_bancofiducia"); }
        if (!NOMBRE_FIDUCIA) { errores.push("error_nomfiducia"); }
        if (!NIT_FIDUCIA) { errores.push("error_nitfiducia"); }
        if (!DIRECCION_ALCALDIA) { errores.push("error_diralcaldia"); }
        if (!TELEFONO_ALCALDIA) { errores.push("error_telefono"); }
        if (!CORREO_ELECTRONICO_ALCALDIA) { errores.push("error_correo"); }
        if (!NOMBRE_SEC_HACIENDA) { errores.push("error_hacienda"); }
        if (!CUENTA_DESTINO) { errores.push("error_cuentadestino"); }
        if (!BANCO_DESTINO) { errores.push("error_bancdestino"); }
        if (!CONCEPTO_APORTE) { errores.push("error_conceptaporte"); }
        if (!VALOR_CONCEPTO) { errores.push("error_valorconcept"); }
        if (!VALOR_CARTERA) { errores.push("error_cartera"); }
        console.log(errores.length);
        this.setState({ errores: errores });
        if (errores.length > 0) {
            return false;
        }
        var datosEnviar = {
            ID_COD_DPTO: ID_COD_DPTO,
            ID_COD_MPIO: ID_COD_MPIO,
            NOMBRE: NOMBRE,
            NIT_ALCALDIA: NIT_ALCALDIA,
            CUENTA_FIDUCIA: CUENTA_FIDUCIA,
            BANCO_FIDUCIA: BANCO_FIDUCIA,
            NOMBRE_FIDUCIA: NOMBRE_FIDUCIA,
            NIT_FIDUCIA: NIT_FIDUCIA,
            DIRECCION_ALCALDIA: DIRECCION_ALCALDIA,
            TELEFONO_ALCALDIA: TELEFONO_ALCALDIA,
            CORREO_ELECTRONICO_ALCALDIA: CORREO_ELECTRONICO_ALCALDIA,
            NOMBRE_SEC_HACIENDA: NOMBRE_SEC_HACIENDA,
            CUENTA_DESTINO: CUENTA_DESTINO,
            BANCO_DESTINO: BANCO_DESTINO,
            CONCEPTO_APORTE: CONCEPTO_APORTE,
            VALOR_CONCEPTO: VALOR_CONCEPTO,
            VALOR_CARTERA: VALOR_CARTERA
        }
        Swal.showLoading();
        authAxios.post("alcaldia/registrar", datosEnviar)
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                if (datosRespuesta.data.Status) {
                    Swal.close();
                    Swal.fire(
                        'Alcaldías!',
                        datosRespuesta.data.msj,
                        'success'
                    )
                    this.props.history.push("/MasterAlcaldias");
                } else {
                    Swal.close();
                    Swal.fire(
                        'Alcaldías!',
                        datosRespuesta.data.msj,
                        'error'
                    )
                }
            })
            .catch(console.log)
    }
    cargadpto() {
        Swal.showLoading();
        authAxios.get("departamentos/index/0")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ datosCargados: true, departamentos: datosRespuesta.data.data, load: '' });
                Swal.close();
            })
            .catch(console.log);
    }
    municipios(dep) {
        Swal.showLoading();
        authAxios.get("municipios_visitas/buscardepartamento/" + dep)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ datosCargados: true, municipios: datosRespuesta.data, load: '' });
                window.$("#ID_COD_MPIO").focus();
                Swal.close();
            })
            .catch(console.log);
    }
    buscarmunicipios() {
        var dep = document.getElementById("ID_COD_DPTO").value;
        this.municipios(dep);
    }
    componentDidMount() {
        this.cargadpto()
    }
    render() {
        const { departamentos, municipios, NOMBRE, NIT_ALCALDIA, CUENTA_FIDUCIA, BANCO_FIDUCIA, NOMBRE_FIDUCIA, NIT_FIDUCIA, DIRECCION_ALCALDIA, TELEFONO_ALCALDIA, CORREO_ELECTRONICO_ALCALDIA, NOMBRE_SEC_HACIENDA, CUENTA_DESTINO, BANCO_DESTINO, CONCEPTO_APORTE, VALOR_CONCEPTO, VALOR_CARTERA } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                <b>REGISTRO DE ALCALDÍAS</b>
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.enviarDatos}>
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                                <div className="col-md-2">
                                                    <label htmlFor="NIT_ALCALDIA">NIT Alcaldía</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_nit")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="NIT_ALCALDIA" id="NIT_ALCALDIA" value={NIT_ALCALDIA} placeholder="Nit Alcaldía" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el NIT</small>
                                                </div>
                                                <div className="col-md-10">
                                                    <label htmlFor="NOMBRE">Nombre</label>
                                                    <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_nombre")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="NOMBRE" id="NOMBRE" value={NOMBRE} placeholder="Nombre" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    <small id="helpId" className="invalid-feedback">Digite la Alcaldía</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-3">
                                                    <label htmlFor="ID_COD_DPTO">Departamento</label>
                                                    <select name="ID_COD_DPTO"
                                                        id="ID_COD_DPTO"
                                                        className={((this.verificarError("error_id_departamento")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={e => {
                                                            this.buscarmunicipios(e);
                                                            this.cambioValor(e)
                                                        }}>
                                                        <option value="">Seleccione el Departamento</option>
                                                        {
                                                            departamentos.map((itemDepartamentos) => (
                                                                <option key={itemDepartamentos.ID_DEPARTAMENTO} value={itemDepartamentos.ID_DEPARTAMENTO}>{itemDepartamentos.NOMBRE}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Departamento</small>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="ID_COD_MPIO">Municipio</label>
                                                    <select name="ID_COD_MPIO" id="ID_COD_MPIO"
                                                        className={((this.verificarError("error_id_municipio")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione el Municipio</option>
                                                        {
                                                            municipios.map((item) => (
                                                                <option key={item.ID_MUNICIPIO} value={item.ID_MUNICIPIO}>{item.NOMBRE}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Municipio</small>
                                                </div>
                                                <div className="col-md-6">
                                                    <label htmlFor="NOMBRE_SEC_HACIENDA">Nombre Sec. Hacienda</label>
                                                    <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_hacienda")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="NOMBRE_SEC_HACIENDA" id="NOMBRE_SEC_HACIENDA" value={NOMBRE_SEC_HACIENDA} placeholder="Nombre Sec. Hacienda" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    <small id="helpId" className="invalid-feedback">Digite el Nombre Sec. Hacienda</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-4">
                                                    <label htmlFor="DIRECCION_ALCALDIA">Dirección</label>
                                                    <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_diralcaldia")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="DIRECCION_ALCALDIA" id="DIRECCION_ALCALDIA" value={DIRECCION_ALCALDIA} placeholder="Dirección" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    <small id="helpId" className="invalid-feedback">Digite la Dirección</small>
                                                </div>
                                                <div className="col-md-4">
                                                    <label htmlFor="TELEFONO_ALCALDIA">Teléfono</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_telefono")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="TELEFONO_ALCALDIA" id="TELEFONO_ALCALDIA" value={TELEFONO_ALCALDIA} placeholder="Teléfono" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Teléfono</small>
                                                </div>
                                                <div className="col-md-4">
                                                    <label htmlFor="CORREO_ELECTRONICO_ALCALDIA">Correo Electrónico</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faAt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_correo")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="CORREO_ELECTRONICO_ALCALDIA" id="CORREO_ELECTRONICO_ALCALDIA" value={CORREO_ELECTRONICO_ALCALDIA} placeholder="Correo Electrónico" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Correo Electrónico</small>
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>INFORMACIÓN FIDUCIA</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-2">
                                                    <label htmlFor="CUENTA_FIDUCIA">Cuenta Fiducia</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_ctafiducia")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="CUENTA_FIDUCIA" id="CUENTA_FIDUCIA" value={CUENTA_FIDUCIA} placeholder="Cuenta Fiducia" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite la Cuenta Fiducia</small>
                                                </div>
                                                <div className="col-md-10">
                                                    <label htmlFor="BANCO_FIDUCIA">Banco Fiducia</label>
                                                    <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_bancofiducia")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="BANCO_FIDUCIA" id="BANCO_FIDUCIA" value={BANCO_FIDUCIA} placeholder="Banco Fiducia" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    <small id="helpId" className="invalid-feedback">Digite el Banco Fiducia</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-2">
                                                    <label htmlFor="NIT_FIDUCIA">NIT Fiducia</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_nitfiducia")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="NIT_FIDUCIA" id="NIT_FIDUCIA" value={NIT_FIDUCIA} placeholder="NIT Fiducia" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el NIT Fiducia</small>
                                                </div>
                                                <div className="col-md-10">
                                                    <label htmlFor="NOMBRE_FIDUCIA">Nombre Fiducia</label>
                                                    <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_nomfducia")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="NOMBRE_FIDUCIA" id="NOMBRE_FIDUCIA" value={NOMBRE_FIDUCIA} placeholder="Nombre Fiducia" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    <small id="helpId" className="invalid-feedback">Digite el Nombre Fiducia</small>
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>INFORMACIÓN APORTES MUNICIPALES</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-2">
                                                    <label htmlFor="CUENTA_DESTINO">Cuenta Destino</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_cuentadestino")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="CUENTA_DESTINO" id="CUENTA_DESTINO" value={CUENTA_DESTINO} placeholder="Cuenta Destino" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite la Cuenta Destino</small>
                                                </div>
                                                <div className="col-md-5">
                                                    <label htmlFor="BANCO_DESTINO">Banco Destino</label>
                                                    <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_bancdestino")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="BANCO_DESTINO" id="BANCO_DESTINO" value={BANCO_DESTINO} placeholder="Banco Destino" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    <small id="helpId" className="invalid-feedback">Digite el Banco Destino</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-5">
                                                    <label htmlFor="CONCEPTO_APORTE">Concepto Aporte</label>
                                                    <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_conceptaporte")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="CONCEPTO_APORTE" id="CONCEPTO_APORTE" value={CONCEPTO_APORTE} placeholder="Concepto Aporte" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    <small id="helpId" className="invalid-feedback">Digite el Concepto Aporte</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="VALOR_CONCEPTO">Valor Concepto</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_valorconcept")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="VALOR_CONCEPTO" id="VALOR_CONCEPTO" value={VALOR_CONCEPTO} placeholder="Valor Concepto" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Valor Concepto</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="VALOR_CARTERA">Valor Cartera</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_cartera")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="VALOR_CARTERA" id="VALOR_CARTERA" value={VALOR_CARTERA} placeholder="Valor Cartera" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Valor Cartera</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-success btn-sm"><FontAwesomeIcon icon={faSave} />&nbsp;&nbsp;Crear Alcaldia</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/MasterAlcaldias"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Crear;